// Запросы «Запуска» (задача D15; сервер — D14): состояние `GET /api/v1/launch` (опрос раз в 60 с, событие потока `launch` —
// перезапрос) и сотрудники отдела Квалификация для выбора дежурных `GET /api/v1/omni/staff` (только admin; Омнидеск не
// ответил — 502 `omni_read_failed`: экран и «Остановить» работают и без этого списка).
//
// «Кнопки и стадии сделок» (Ruling 125): `GET /api/v1/bitrix/targets` — назначения и справочники для выбора. Без опроса:
// назначения меняются редко, а справочники сервер помнит 10 минут; перечитывает событие потока `launch` (версия настроек) и
// возврат на вкладку. Не прочитанный Битриксом справочник сервер не запоминает, и такой запрос ждёт его до 25 с.
//
// «Как Анна квалифицирует» (W3-6): `GET /api/v1/settings/choices` — выборы настроек разделов qualify, reply, series и bitrix, запись —
// `PUT /api/v1/settings` с патчем одного пути. Без опроса — как у «Кнопок и стадий»: перечитывает событие потока `launch`
// (правка настроек меняет их версию) и возврат на вкладку.
import {
  BitrixTargetsStateSchema,
  LaunchStateSchema,
  OmniStaffResponseSchema,
  SettingChoicesSchema,
  type StaffRef,
} from '@contract/index.js';
import { queryOptions } from '@tanstack/react-query';
import { apiGet } from '@/api/client';
import { qk } from '@/api/keys';

export const LAUNCH_PATH = '/api/v1/launch';
export const LAUNCH_CHANGES_PATH = '/api/v1/launch/changes';
export const OMNI_STAFF_PATH = '/api/v1/omni/staff?department=QUALIFIER';
export const UNDO_PATH = '/api/v1/undo';
export const BITRIX_TARGETS_PATH = '/api/v1/bitrix/targets';
export const SETTINGS_PATH = '/api/v1/settings';
export const SETTING_CHOICES_PATH = '/api/v1/settings/choices';

/** Как часто экран перечитывает состояние без потока, мс. */
export const LAUNCH_POLL_MS = 60_000;

export const launchQuery = queryOptions({
  queryKey: qk.launch,
  queryFn: ({ signal }) => apiGet(LAUNCH_PATH, LaunchStateSchema, { signal }),
  refetchInterval: LAUNCH_POLL_MS,
});

/** Куда Анна передаёт сделку: назначения, воронки и стадии Битрикса, кнопки квалификации Омнидеска. */
export const bitrixTargetsQuery = queryOptions({
  queryKey: qk.bitrixTargets,
  queryFn: ({ signal }) => apiGet(BITRIX_TARGETS_PATH, BitrixTargetsStateSchema, { signal }),
});

/** Как Анна квалифицирует: выборы настроек — название, пояснение, варианты словами, значение и умолчание. */
export const settingChoicesQuery = queryOptions({
  queryKey: qk.settingChoices,
  queryFn: ({ signal }) => apiGet(SETTING_CHOICES_PATH, SettingChoicesSchema, { signal }),
});

/** Кого можно назначить дежурным: активные сотрудники отдела по фамилии (список берут при открытии выбора). */
export const staffQuery = queryOptions({
  queryKey: qk.staff,
  queryFn: async ({ signal }): Promise<readonly StaffRef[]> => (await apiGet(OMNI_STAFF_PATH, OmniStaffResponseSchema, { signal })).staff,
  staleTime: 60_000,
});
